import { render, staticRenderFns } from "./GraphqlPlayground.vue?vue&type=template&id=4b879310&scoped=true&"
import script from "./GraphqlPlayground.vue?vue&type=script&lang=js&"
export * from "./GraphqlPlayground.vue?vue&type=script&lang=js&"
import style0 from "./GraphqlPlayground.vue?vue&type=style&index=0&id=4b879310&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b879310",
  null
  
)

export default component.exports